import LanguageProvider from './LanguageProviderContainer'

export default LanguageProvider
